import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import moment from 'moment';
import 'moment/locale/es-mx';
import { Grid, Col, ControlLabel, AutoComplete, Button, Panel, Dropdown, Icon, DatePicker, IntlProvider } from 'rsuite';
import esES from 'rsuite/lib/IntlProvider/locales/es_ES';
import enUS from 'rsuite/lib/IntlProvider/locales/en_US';
import dateFnsFormat from 'date-fns/format';
import dateFnsEsLocale from 'date-fns/locale/es';
import Layout from '../../components/Layout';
import TableList from '../../components/TableList';
import Swal from 'sweetalert2';
import $ from 'jquery';

class Absences extends Component{
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.search = this.search.bind(this);
        this.updateColumns = this.updateColumns.bind(this);

        this.state = {
            start_date:moment().startOf('month').format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
            employee:this.props.t('screen.reports.all'),
            employees:[],
            data:[],
            columns:[
                {title:'employee', name:'employee', visible:true, width:'60%'},
                {title:'date', name:'date', visible:true, width:'40%'}
            ],
            list:[]
        }
    }


    async componentDidMount(){
        // Mismo idioma para moment que el resto de los reportes — moment usa
        // su propio locale global, independiente del de i18next.
        moment.locale(this.props.i18n.language && this.props.i18n.language.startsWith('en') ? 'en' : 'es-mx');

        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);
        var req = {
            api:'accounts',
            url:'employees/by-account/'+accountId,
            method:'GET',
            requireToken:true
        }

        var employees = await this.props.fetchRequest(req);
        var data = [this.props.t('screen.reports.all')];
        employees.map((e)=>(
            data.push(e.firstName+' '+e.lastName+' '+(e.maternalSurname === null ? '' : e.maternalSurname))
        ));

        // Igual que Entries/CheckInFace/Visit/Overtime: al construir aquí,
        // ya con las traducciones resueltas, se refresca employee junto con
        // data para no quedar congelado con el valor del idioma equivocado
        // que trae el constructor (i18next puede arrancar en el idioma del
        // navegador antes de resolver al idioma real de la app).
        await this.setState({employees: employees, data: data, employee: data[0]});

        await this.search(null, 'reports/absences');
    }

    componentDidUpdate(){
        var data = this.state.data;
        if(data.length > 0){
            if(data[0] !== this.props.t('screen.reports.all')){
                data[0] = this.props.t('screen.reports.all');

                this.setState({data: data, employee: data[0]});
            }
        }
    }


    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    // El DatePicker de rsuite entrega un objeto Date (o null si se limpia),
    // no un string como el <input type="date"> nativo que reemplaza — el
    // resto del componente (search(), el estado) sigue esperando 'YYYY-MM-DD'.
    handleDateChange(name, date){
        if(date){
            this.setState({[name]: moment(date).format('YYYY-MM-DD')});
        }
    }


    async search(e, url){
        $('.rs-btn-default').blur();
        var id = '';
        var error = "";
        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);
        url = url+'-by-account/'+accountId;

        if(this.state.employee === this.props.t('screen.reports.all')){
            id = 'all';
        }else if(this.state.employee === ""){
            error = this.props.t('error_alert.no_employee');
        }else{
            var index = this.state.employees.findIndex(obj =>
                obj.firstName+' '+obj.lastName+' '+obj.maternalSurname === this.state.employee
            );

            id = this.state.employees[index].id;
        }

        var obj = {
            startDate: this.state.start_date,
            endDate: this.state.end_date,
            employeeId: id
        };

        var req = {
            api: 'reports',
            url: url,
            obj: obj,
            method: 'POST',
            modal: this.props.modal_loader,
            message_modal: this.props.t('modal.spin.searching'),
            requireToken: true
        };

        if(error === ""){
            var request = await this.props.fetchRequest(req);
            var list = [];

            if(request !== undefined){
                request.timeCards.map(r =>
                    list.push([
                        r.employee.name,
                        moment(r.date).format('DD/MM/YYYY')
                    ])
                );
            }

            // Mismo defer de 1 tick que el resto de los reportes: resetTable()/
            // setTable() corren en el callback de setState, después de que
            // React ya volvió a renderizar el <tbody> con "list" — evita el
            // "Failed to execute 'removeChild'" de destruir la tabla antes de
            // que fixedColumns termine su propio armado diferido. Antes esto
            // se cubría con dos setTimeout (500/1000ms) que además reabrían
            // el modal de carga a la mitad de la búsqueda (parpadeo
            // cerrado→abierto→cerrado) sin necesidad, ya que fetchRequest
            // arriba ya lo maneja durante todo el fetch.
            this.setState({list: list}, ()=>{
                setTimeout(()=>{
                    this.table.resetTable();
                    this.table.setTable();
                }, 0);
            });
        }else{
            Swal.fire('Error', error, 'error');
        }
    }

    updateColumns(e, i){
        var columns = this.state.columns;
        columns[i].visible = e.target.checked;
        this.setState({columns: columns});
    }

    render(){
        const {t} = this.props;
        // El DatePicker de rsuite trae su propio calendario/textos ("Today",
        // días/meses) en inglés por defecto — IntlProvider lo traduce al
        // idioma actual de la app (i18next). Además, el mes del header del
        // calendario lo formatea rsuite con date-fns (no con moment, a pesar
        // de usar tokens estilo moment), así que necesita su propio
        // formatDate aparte.
        const isEnglish = this.props.i18n.language && this.props.i18n.language.startsWith('en');
        const rsuiteLocale = isEnglish ? enUS : esES;
        const formatDate = (date, formatStr) => isEnglish ?
            dateFnsFormat(date, formatStr)
            : dateFnsFormat(date, formatStr, {locale: dateFnsEsLocale});
        return (
            <IntlProvider locale={rsuiteLocale} formatDate={formatDate}>
            <Layout {...this.props}>
                <Grid fluid>
                    <Col xs={24}>
                        <h3 className="s-title-page">{t('screen.reports.absences.name')}</h3>
                    </Col>
                    <Col xs={24}>
                    <Panel className="panel-general" shaded>
                        <Col xs={24} sm={3}>
                            <ControlLabel className="s-table-titles">{t('screen.reports.absences.form.start_date')}</ControlLabel>
                            <DatePicker
                                format="DD/MM/YYYY"
                                value={this.state.start_date ? moment(this.state.start_date).toDate() : null}
                                onChange={(date)=>this.handleDateChange('start_date', date)}
                                cleanable={false}
                                oneTap
                                style={{width:'100%'}}
                                size="sm"
                            />
                        </Col>

                        <Col xs={24} sm={3}>
                            <ControlLabel className="s-table-titles">{t('screen.reports.absences.form.end_date')}</ControlLabel>
                            <DatePicker
                                format="DD/MM/YYYY"
                                value={this.state.end_date ? moment(this.state.end_date).toDate() : null}
                                onChange={(date)=>this.handleDateChange('end_date', date)}
                                cleanable={false}
                                oneTap
                                style={{width:'100%'}}
                                size="sm"
                            />
                        </Col>

                        <Col xs={24} sm={5} className="form-group">
                            <ControlLabel className="s-table-titles">{t('screen.reports.absences.form.employee')}</ControlLabel>
                            <AutoComplete
                                data={this.state.data}
                                value={this.state.employee}
                                onChange={(e)=>this.handleChange({target:{name:'employee', value:e}})}
                                id="employee"
                                name="employee"
                                autoComplete="off"
                                size="sm"
                                required
                            />
                        </Col>

                        <Col xs={24} sm={7} style={{marginTop:30, whiteSpace:'nowrap'}}>
                            <Button className="s-btn-primary" onClick={(e)=>this.search(e, 'reports/absences')}>
                                {t('button.search')}
                            </Button>
                            <Button
                                className="toolbar-btn-outline"
                                disabled={this.state.list.length === 0}
                                style={{marginLeft:8}}
                                onClick={(e)=> this.state.list.length > 0 && this.search(e, 'reports/valid-absences')}
                            >
                                <Icon icon="refresh" /> {t('button.support_doc')}
                            </Button>
                            <Button onClick={(e)=>this.props.history.goBack()} style={{marginLeft:8}}>
                                {t('button.return')}
                            </Button>
                        </Col>
                        <Col xs={24} sm={6} style={{marginTop:30, textAlign:'right', whiteSpace:'nowrap'}}>
                            <Dropdown title={t('general.table.export')} placement="bottomEnd" className="export-dropdown" style={{display:'inline-block'}}>
                                <Dropdown.Item disabled={this.state.list.length === 0} onClick={()=> this.state.list.length > 0 && this.table && this.table.triggerButton('buttons-excel')}>Excel</Dropdown.Item>
                                <Dropdown.Item disabled={this.state.list.length === 0} onClick={()=> this.state.list.length > 0 && this.table && this.table.triggerButton('buttons-pdf')}>PDF</Dropdown.Item>
                            </Dropdown>
                            <Dropdown
                                title={<><Icon icon="columns" /> {t('general.table.columns')}</>}
                                placement="bottomEnd"
                                className="columns-dropdown"
                                style={{marginLeft:8, display:'inline-block'}}
                            >
                                {this.state.columns.map((c, i)=>(
                                    <Dropdown.Item key={i}>
                                        <label className="col-visibility-item" onClick={(e)=>e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                checked={c.visible}
                                                onChange={(e)=>this.updateColumns(e, i)}
                                            /> {t('screen.reports.absences.columns.'+c.name)}
                                        </label>
                                    </Dropdown.Item>
                                ))}
                            </Dropdown>
                        </Col>
                        <Col xs={24}>
                            <TableList
                                {...this.props}
                                onRef={ref => this.table = ref}
                                columns={this.state.columns}
                                btnNew={false}
                                data={this.state.list}
                                actions={[]}
                                screen={"absences"}
                                searching={false}
                                report={true}
                                table_title={[]}
                                filename={t('screen.reports.absences.name')}
                                scroll={true}
                                scrollY="calc(100vh - 340px)"
                                widths={this.state.columns.map(c => c.width)}
                                search={this.search}
                            />
                        </Col>
                    </Panel>
                    </Col>
                </Grid>
            </Layout>
            </IntlProvider>
        )
    }
}

export default withTranslation('translations')(Absences);
